import { render, staticRenderFns } from "./customArea.vue?vue&type=template&id=24d18182"
import script from "./customArea.vue?vue&type=script&lang=js"
export * from "./customArea.vue?vue&type=script&lang=js"
import style0 from "./customArea.vue?vue&type=style&index=0&id=24d18182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports